import React from "react";
import { Link } from "react-router-dom";

const Company = () => {
  return (
    <div className="bg-gray-100">
      <section className="container mx-auto py-16 text-center">
        {/* 企業情報 */}
        <div className="mb-16">
          <h1 className="text-3xl font-bold text-gray-800">企業情報</h1>
          <img src="/images/image4.png" alt="装飾ライン" className="mx-auto my-2 w-32" />
        </div>
        <div className="flex flex-col justify-center items-center space-y-8">
          {/* 会社概要ボタン */}
          <Link
            to="/company/companyOverview"
            className="bg-primary text-white w-80 h-32 text-4xl flex justify-center items-center rounded-lg shadow-lg hover:opacity-80 transition duration-300"
          >
            会社概要
          </Link>

          {/* 当社理念ボタン */}
          <Link
            to="/company/philosophy"
            className="bg-primary text-white w-80 h-32 text-4xl flex justify-center items-center rounded-lg shadow-lg hover:opacity-80 transition duration-300"
          >
            当社理念
          </Link>

          {/* 組織図ボタン */}
          <Link
            to="/company/organization"
            className="bg-primary text-white w-80 h-32 text-4xl flex justify-center items-center rounded-lg shadow-lg hover:opacity-80 transition duration-300"
          >
            組織図
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Company;
